const refundStatus = {
  open: 0,
  canceled: 1,
  analysed: 2
};

module.exports = refundStatus;
